import { SET_KEY_DOWN_EVENT } from '../types';

const initialState = {
  status: false,
};

const keyDownEvent = (state = initialState, action) => {
  switch (action.type) {
    case SET_KEY_DOWN_EVENT:
      return { ...state, status: action.status };
    default:
      return state;
  }
};

export default keyDownEvent;
